export default "__VITE_ASSET__DcURrSRf__"